export default __webpack_public_path__ + "static/media/MyPhoto.48505f91.png";